import { render } from "./RuiSupport.vue?vue&type=template&id=0e8f9422"
const script = {}
script.render = render

export default script